import { CheckGateOptions } from "./types";

/**
 * Registry of all feature gates used in the application.
 * To add a new gate, simply add an entry to this map.
 */
export const GATES = {
  ENABLE_STANDALONE_LABS: {
    gateName: "enable_standalone_labs",
    fallback: false,
  },
  ENABLE_PRACTICE_LABS: {
    gateName: "enable_practice_labs",
    fallback: false,
  },
  ENABLE_MODULAR_ASSESSMENT_FILTER: {
    gateName: "enable_modular_assessment_filter",
    fallback: false,
  },
  ENABLE_SCORM_CONTENT: {
    gateName: "enable_scorm_content",
    fallback: false,
  },
  ENABLE_STORE_PROMOTIONS: {
    gateName: "enable_store_promotions",
    fallback: true,
  },
  ENABLE_GRADED_LABS_RETIRING: {
    gateName: "enable_graded_labs_retiring",
    fallback: false,
  },
  PUBLISHERS_FILTER: {
    gateName: "publishers_filter",
    fallback: false,
  },
  ENABLE_COLLECTIONS_RETRIEVAL: {
    gateName: "enable_collections_retrieval",
    fallback: true,
  },
  ENABLE_ILT_BLADE: {
    gateName: "enable_ilt_blade",
    fallback: true,
  },
  EMAIL_NOTIFICATION_OPT_IN: {
    gateName: "email_communication_opt_in",
    fallback: false,
  },
  ENABLE_MINDTICKLE_EXTERNAL_LAUNCH: {
    gateName: "enable_mindtickle_external_launch",
    fallback: false,
  },
  ENABLE_RENEWAL_ORDERS: {
    gateName: "enable_renewal_orders",
    fallback: true,
  },
  ENABLE_AI_LEARNING_EXPERIENCE: {
    gateName: "enable_ai_learning_experience",
    fallback: true,
  },
  ENABLE_UNAUTH_TOPIC_BASED_CONTENT: {
    gateName: "enable_unauth_topic_based_content",
    fallback: false,
  },
  ENABLE_REV_UP_RECERT: {
    gateName: "enable_rev_up_recert",
    fallback: false,
  },
  ENABLE_OTSEC_ANNOUNCEMENT: {
    gateName: "enable_otsec_announcement",
    fallback: false,
  },
  ENABLE_LTI_PROVISIONING_SPLASH: {
    gateName: "enable_lti_provisioning_splash",
    fallback: true,
  },
  ENABLE_SJC_OUTAGE: {
    gateName: "enable_sjc_outage",
    fallback: false,
  },
  ENABLE_VERIFONE_TIMEOUT: {
    gateName: "enable_verifone_timeout",
    fallback: false,
  },
  ENABLE_LOCK_CONTENT: {
    gateName: "enable_lock_content",
    fallback: false,
  },
  ENABLE_SKILLSOFT_EOL: {
    gateName: "enable_skillsoft_eol",
    fallback: false,
  },
  ENABLE_FOR_YOU_REDESIGN: {
    gateName: "enable_for_you_redesign",
    fallback: false,
  },
  USER_INACTIVITY_TIMEOUT: {
    gateName: "user_inactivity_timeout",
    fallback: false,
  },
  ENABLE_INZONE_TILES: {
    gateName: "enable_inzone_tiles",
    fallback: false,
  },
  ENABLE_SESSION_TIMEOUT_WARNING: {
    gateName: "enable_session_timeout_warning",
    fallback: false,
  },
  ENABLE_CERTIFICATION_FILTER: {
    gateName: "enable_certification_filter",
    fallback: false,
  },
  ENABLE_CUSTOM_MARQUEE: {
    gateName: "enable_custom_marquee",
    fallback: false,
  },
} as const satisfies Record<string, CheckGateOptions>;

export type GateKey = keyof typeof GATES;
